module.exports = __webpack_public_path__ + "img/sources.54d61de9.gif";